import { render, staticRenderFns } from "./Transmittals.vue?vue&type=template&id=67cf6bfd&scoped=true&"
import script from "./Transmittals.vue?vue&type=script&lang=js&"
export * from "./Transmittals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf6bfd",
  null
  
)

export default component.exports